// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../overlays/Modal.res.js";
import * as React from "react";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";

function wait(ms) {
  return new Promise((resolve, param) => {
    setTimeout(() => resolve(), ms);
  });
}

function SpinnerModal(props) {
  let __loopMessages = props.loopMessages;
  let opened = props.opened;
  let loopMessages = __loopMessages !== undefined ? __loopMessages : [];
  let url = Navigation.useUrl();
  let match = React.useState(() => I18n.t("Please wait until the operation is complete"));
  let setMessage = match[1];
  React.useEffect(() => {
    if (opened) {
      let index = {
        contents: 0
      };
      let loop = async () => {
        while (index.contents <= loopMessages.length) {
          let currentIndex = index.contents;
          let randomTime = Math.random() * 3500.0 + 1000.0;
          await wait(randomTime | 0);
          setMessage(param => Stdlib_Option.getOr(loopMessages[currentIndex], I18n.t("Please wait until the operation is complete")));
          index.contents = currentIndex + 1 | 0;
        };
      };
      loop();
    }
  }, [opened]);
  let shouldBlockOnRouteChange = React.useCallback(nextRoute => {
    if (opened) {
      return url.pathname !== nextRoute;
    } else {
      return false;
    }
  }, [opened]);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx(Navigation.Prompt.make, {
        message: I18n.t("Warning: an operation is still in progress."),
        shouldBlockOnRouteChange: shouldBlockOnRouteChange
      }),
      JsxRuntime.jsx(Modal.make, {
        children: JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Placeholder.make, {
            status: "Loading",
            customText: match[0]
          }),
          spaceBottom: "large"
        }),
        opened: opened,
        title: props.title,
        hideFooter: true
      })
    ]
  });
}

let make = React.memo(SpinnerModal);

export {
  make,
}
/* make Not a pure module */
